/**
 * ISO 639-1 standard language codes
 *
 * Please, contribute if you need a missing language
 */
export enum Lang {
  /**
   * English (United States)
   */
  EN_US = 'en-US',

  /**
   * English (United Kingdom)
   */
  EN_GB = 'en-GB',

  /**
   * English (Canada)
   */
  EN_CA = 'en-CA',

  /**
   * English (Australia)
   */
  EN_AU = 'en-AU',

  /**
   * Spanish (Spain)
   */
  ES = 'es',

  /**
   * French (Standard)
   */
  FR = 'fr',

  /**
   * German (Standard)
   */
  DE = 'de',

  /**
   * Portuguese (Portugal)
   */
  PT = 'pt',

  /**
   * Portuguese (Brazil)
   */
  PT_BR = 'pt-BR',

  /**
   * Russian
   */
  RU = 'ru',

  /**
   * Japanese
   */
  JA = 'ja',

  /**
   * Chinese (PRC)
   */
  ZH_CN = 'zh-CN',

  /**
   * Afrikaans
   */
  AF = 'af',

  /**
   * Arabic (Standard)
   */
  AR = 'ar',

  /**
   * Arabic (Algeria)
   */
  AR_DZ = 'ar-DZ',

  /**
   * Arabic (Kuwait)
   */
  AR_KW = 'ar-KW',

  /**
   * Arabic (Libya)
   */
  AR_LY = 'ar-LY',

  /**
   * Arabic (Morocco)
   */
  AR_MA = 'ar-MA',

  /**
   * Arabic (Saudi Arabia)
   */
  AR_SA = 'ar-SA',

  /**
   * Arabic (Tunisia)
   */
  AR_TN = 'ar-TN',

  /**
   * Belarusian
   */
  BE = 'be',

  /**
   * Bulgarian
   */
  BG = 'bg',

  /**
   * Bambara
   */
  BM = 'bm',

  /**
   * Bengali
   */
  BN = 'bn',

  /**
   * Tibetan
   */
  BO = 'bo',

  /**
   * Breton
   */
  BR = 'br',

  /**
   * Bosnian
   */
  BS = 'bs',

  /**
   * Catalan
   */
  CA = 'ca',

  /**
   * Czech
   */
  CS = 'cs',

  /**
   * Chuvash
   */
  CV = 'cv',

  /**
   * Welsh
   */
  CY = 'cy',

  /**
   * Danish
   */
  DA = 'da',

  /**
   * German (Austria)
   */
  DE_AT = 'de-AT',

  /**
   * German (Switzerland)
   */
  DE_CH = 'de-CH',

  /**
   * Divehi
   */
  DV = 'dv',

  /**
   * Greek
   */
  EL = 'el',

  /**
   * English (Ireland)
   */
  EN_IE = 'en-IE',

  /**
   * English (New Zealand)
   */
  EN_NZ = 'en-NZ',

  /**
   * Esperanto
   */
  EO = 'eo',

  /**
   * Spanish (Dominican Republic)
   */
  ES_DO = 'es-DO',

  /**
   * Estonian
   */
  ET = 'et',

  /**
   * Basque
   */
  EU = 'eu',

  /**
   * Farsi
   */
  FA = 'fa',

  /**
   * Finnish
   */
  FI = 'fi',

  /**
   * Faeroese
   */
  FO = 'fo',

  /**
   * French (Canada)
   */
  FR_CA = 'fr-CA',

  /**
   * French (Switzerland)
   */
  FR_CH = 'fr-CH',

  /**
   * Western Frisian
   */
  FY = 'fy',

  /**
   * Gaelic (Scotland)
   */
  GD = 'gd',

  /**
   * Galician
   */
  GL = 'gl',

  /**
   * Gujarati
   */
  GU = 'gu',

  /**
   * Hebrew
   */
  HE = 'he',

  /**
   * Hindi
   */
  HI = 'hi',

  /**
   * Croatian
   */
  HR = 'hr',

  /**
   * Hungarian
   */
  HU = 'hu',

  /**
   * Armenian
   */
  HY_AM = 'hy-AM',

  /**
   * Indonesian
   */
  ID = 'id',

  /**
   * Icelandic
   */
  IS = 'is',

  /**
   * Italian (Standard)
   */
  IT = 'it',

  /**
   * Javanese
   */
  JV = 'jv',

  /**
   * Georgian
   */
  KA = 'ka',

  /**
   * Kazakh
   */
  KK = 'kk',

  /**
   * Central Khmer
   */
  KM = 'km',

  /**
   * Kannada
   */
  KN = 'kn',

  /**
   * Korean
   */
  KO = 'ko',

  /**
   * Kyrgyz
   */
  KY = 'ky',

  /**
   * Luxembourgish
   */
  LB = 'lb',

  /**
   * Lao
   */
  LO = 'lo',

  /**
   * Lithuanian
   */
  LT = 'lt',

  /**
   * Latvian
   */
  LV = 'lv',

  /**
   * Maori
   */
  MI = 'mi',

  /**
   * Macedonian (FYROM)
   */
  MK = 'mk',

  /**
   * Malayalam
   */
  ML = 'ml',

  /**
   * Mongolian
   */
  MN = 'mn',

  /**
   * Marathi
   */
  MR = 'mr',

  /**
   * Malaysian
   */
  MS = 'ms',

  /**
   * Maltese
   */
  MT = 'mt',

  /**
   * Burmese
   */
  MY = 'my',

  /**
   * Norwegian (Bokmal)
   */
  NB = 'nb',

  /**
   * Nepali
   */
  NE = 'ne',

  /**
   * Dutch (Standard)
   */
  NL = 'nl',

  /**
   * Dutch (Belgium)
   */
  NL_BE = 'nl-BE',

  /**
   * Norwegian (Nynorsk)
   */
  NN = 'nn',

  /**
   * Punjabi
   */
  PA_IN = 'pa-IN',

  /**
   * Polish
   */
  PL = 'pl',

  /**
   * Romanian
   */
  RO = 'ro',

  /**
   * Sindhi
   */
  SD = 'sd',

  /**
   * Northern Sami
   */
  SE = 'se',

  /**
   * Sinhala
   */
  SI = 'si',

  /**
   * Slovak
   */
  SK = 'sk',

  /**
   * Slovenian
   */
  SL = 'sl',

  /**
   * Albanian
   */
  SQ = 'sq',

  /**
   * Serbian
   */
  SR = 'sr',

  /**
   * Swati
   */
  SS = 'ss',

  /**
   * Swedish
   */
  SV = 'sv',

  /**
   * Swahili
   */
  SW = 'sw',

  /**
   * Tamil
   */
  TA = 'ta',

  /**
   * Telugu
   */
  TE = 'te',

  /**
   * Tajik
   */
  TG = 'tg',

  /**
   * Thai
   */
  TH = 'th',

  /**
   * Tagalog
   */
  TL_PH = 'tl-PH',

  /**
   * Turkish
   */
  TR = 'tr',

  /**
   * Uighur
   */
  UG_CN = 'ug-CN',

  /**
   * Ukrainian
   */
  UK = 'uk',

  /**
   * Urdu
   */
  UR = 'ur',

  /**
   * Uzbek
   */
  UZ = 'uz',

  /**
   * Vietnamese
   */
  VI = 'vi',

  /**
   * Yoruba
   */
  YO = 'yo',

  /**
   * Chinese (Hong Kong)
   */
  ZH_HK = 'zh-HK',

  /**
   * Chinese (Taiwan)
   */
  ZH_TW = 'zh-TW',
}
